import Checkbox from 'common/components/Checkbox';
import List from 'common/components/List';
import React from 'react';

interface Props {
    id?: string;
    options: { value: string; label: string }[];
    value: string[];
    onChange: (items: string[]) => void;
}

const CheckboxList: React.FunctionComponent<Props> = ({ options, value, onChange }) => {
    return (
        <List spacing="small">
            {options.map((option, idx) => (
                <Checkbox
                    checked={value.includes(option.value)}
                    onChange={() => {
                        const items = [...value];
                        if (items.includes(option.value)) {
                            items.splice(items.indexOf(option.value), 1);
                        } else {
                            items.push(option.value);
                        }
                        onChange(items);
                    }}
                    key={idx}
                    value={option.value}
                >
                    {option.label}
                </Checkbox>
            ))}
        </List>
    );
};

export default CheckboxList;
